import { FC, SVGProps } from 'react'
import theme from 'theme'

const TrendsChartSelectDropdownIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M14.6248 6.1875L8.99985 11.8125L3.37485 6.1875"
      stroke={theme.colors.dustyRoseGray}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default TrendsChartSelectDropdownIcon
